import "./assets/css/bootstrap.min.css";
import "./assets/css/enterprisedigital.css";

import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";

import HomeView from "./pages/HomeView";
import LoginView from "./pages/LoginView";
import {FOLDER_HOMOL} from "./constants";
import React from "react";
import authenticationService from "./services/AuthenticationService";

function App() {
  function PrivateRoute({ children, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) => {   

          let searchUrl = props && props.location &&
          props.location.search && props.location.search;
          let query = searchUrl && new URLSearchParams(searchUrl);
          let externalLogin = query && query.get('sessionId');

          return  authenticationService.checkIfUserAuthenticated() === true && !externalLogin ? (
            children
          ) : (
            <Redirect  to={{
              pathname: `${FOLDER_HOMOL}/login` ,
              state: { search: searchUrl}
            }}/>
          );
        }}
      />
    );
  }

  return (
    <Router>
      <Switch>
        <PrivateRoute exact path={`${FOLDER_HOMOL}/`}>
          <HomeView />
        </PrivateRoute>
        <Route exact path={`${FOLDER_HOMOL}/login`}>
          {<LoginView />}
        </Route>
        <Route path="*">{<Redirect to={`${FOLDER_HOMOL}/`} />}</Route>
      </Switch>
    </Router>
  );
}

export default App;
